import React from "react";
import "./SharedStyles.scss";

interface IProps {
  loadingMessage?: string;
}

const EAFullScreenLoader: React.FC<IProps> = ({ loadingMessage }) => {
  return (
    <div className="fullscreen-loader-container">
      <img src={"https://eaktywni.pl/wp-content/uploads/2024/05/Animation-1716582172685.gif"} alt="loader" />
      {loadingMessage && <h4>{loadingMessage}</h4>}
    </div>
  );
};

export default EAFullScreenLoader;
